import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles({
  wrapper: {
    display: 'flex',
    height: 'calc(100% - 75px)',
    padding: '10px 40px 0',
    ['@media (max-width:760px)']: {
      flexDirection: 'column',
      overflow: 'auto',
      padding: '10px 15px 0'
    },
    ['@media (max-width:600px)']: {
      height: 'calc(100% - 112px)'
    }
  },
  leftSide: {
    width: '300px',
    minWidth: '300px',
    height: '100%',
    marginRight: '40px',
    overflow: 'auto',
    ['@media (max-width:760px)']: {
      width: '345px',
      minWidth: '345px',
      height: 'auto',
      marginBottom: '10px',
      overflow: 'visible'
    }
  },
  rightSide: {
    width: '100%',
    height: '100%',
    overflowX: 'hidden',
    overflowY: 'auto',
    ['@media (max-width:760px)']: {
      height: 'auto',
      overflow: 'visible'
    }
  },
  photo: {
    height: '160px',
    backgroundSize: 'cover',
    backgroundRepeat: 'no-repeat',
    backgroundPosition: 'center',
    backgroundColor: '#E2F5F8',
    marginBottom: '15px'
  },
  title: {
    marginBottom: '15px'
  }
});

export default useStyles;
